import { useScopedSelector } from 'ia-react-core';
import { FeatureState } from '../interfaces/FeatureState';

export default function useFeatureState<T extends FeatureState, T2>(type: { new(): T }, get: (arg: T) => T2) {
  // eslint-disable-next-line new-cap
  const feature = new type();
  return useScopedSelector(feature.featurePath, undefined, get);
}
